import { render, staticRenderFns } from "./MarginModal.vue?vue&type=template&id=244b72f8"
import script from "./MarginModal.vue?vue&type=script&lang=js"
export * from "./MarginModal.vue?vue&type=script&lang=js"
import style0 from "./MarginModal.vue?vue&type=style&index=0&id=244b72f8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports